import { DefaultStyle } from '../../constant';
import { Box } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';

export type PageContainerProps = BoxProps & {
	children: React.ReactNode;
};

const PageContainer = ({ children, ...boxProps }: PageContainerProps) => {
	return (
		<Box
			maxW={'1440px'}
			mx={'auto'}
			px={DefaultStyle.INLINE_PADDING}
			py={DefaultStyle.BLOCK_PADDING}
			{...boxProps}
		>
			{children}
		</Box>
	);
};

export default PageContainer;